import React from 'react'
import {Link} from 'react-router-dom'
import CheckIcon from '../../../../media/felsv/CheckIcon.svg'
import {useDispatch} from 'react-redux'
import {bindActionCreators} from 'redux'
import {actionSujetoExcluidoEmision} from '../../../../actions/action-creators'

const SEFooterResumen = () => {
  const disptach = useDispatch()
  const {sujetoExcluidoClicEmitirFactura} = bindActionCreators(
    actionSujetoExcluidoEmision,
    disptach
  )

  return (
    <div id='w-node-_5c6af4dc-0d52-341f-2ef6-a52695e59ed4-0b1e6fa6' className='w-layout-cell'>
      <div className='card'>
        <div className='w-layout-vflex card-content'>
          <div
            style={{ display: 'flex', gap: '6px', flexWrap: 'wrap', justifyContent: 'space-between', width: '100%', }}>
            <Link to='/otros-documentos/sujeto-excluido/formulario' className='m button transparent botton-footer' >
              <div>Regresar</div>
            </Link>
            <button className='m button botton-footer' onClick={sujetoExcluidoClicEmitirFactura}>
              <div>Emitir</div>
              <img src={CheckIcon} loading='lazy' alt='Emitir' />
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default SEFooterResumen
